"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

function e(e) {
  return e && "object" == typeof e && "default" in e ? e["default"] : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var n = require("react"),
    o = e(n),
    r = e(require("@reach/portal")),
    t = require("@reach/utils"),
    i = e(require("react-focus-lock")),
    a = require("react-remove-scroll");

function u(e, n) {
  if (null == e) return {};
  var o,
      r,
      t = {},
      i = Object.keys(e);

  for (r = 0; r < i.length; r++) {
    n.indexOf(o = i[r]) >= 0 || (t[o] = e[o]);
  }

  return t;
}

require("prop-types");

var c = n.forwardRef(function (e, i) {
  var a = e.isOpen,
      c = void 0 === a || a,
      s = u(e, ["isOpen"]);
  return n.useEffect(function () {
    return t.checkStyles("dialog");
  }, []), c ? o.createElement(r, {
    "data-reach-dialog-wrapper": ""
  }, o.createElement(l, Object.assign({
    ref: i
  }, s))) : null;
}),
    l = n.forwardRef(function (e, r) {
  var c = e.allowPinchZoom,
      l = e.initialFocusRef,
      s = e.onClick,
      f = e.onDismiss,
      d = void 0 === f ? t.noop : f,
      p = e.onMouseDown,
      v = e.onKeyDown,
      m = u(e, ["allowPinchZoom", "initialFocusRef", "onClick", "onDismiss", "onMouseDown", "onKeyDown"]),
      g = n.useRef(null),
      w = n.useRef(null),
      h = t.useForkedRef(w, r),
      E = n.useCallback(function () {
    l && l.current && l.current.focus();
  }, [l]);
  return n.useEffect(function () {
    return w.current ? (n = [], o = [], (e = w.current) ? (Array.prototype.forEach.call(document.querySelectorAll("body > *"), function (r) {
      var t, i;

      if (r !== (null === (t = e.parentNode) || void 0 === t ? void 0 : null === (i = t.parentNode) || void 0 === i ? void 0 : i.parentNode)) {
        var a = r.getAttribute("aria-hidden");
        null !== a && "false" !== a || (n.push(a), o.push(r), r.setAttribute("aria-hidden", "true"));
      }
    }), function () {
      o.forEach(function (e, o) {
        var r = n[o];
        null === r ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", r);
      });
    }) : t.noop) : void 0;
    var e, n, o;
  }, []), o.createElement(i, {
    autoFocus: !0,
    returnFocus: !0,
    onActivation: E
  }, o.createElement(a.RemoveScroll, {
    allowPinchZoom: c
  }, o.createElement("div", Object.assign({}, m, {
    ref: h,
    "data-reach-dialog-overlay": "",
    onClick: t.wrapEvent(s, function (e) {
      g.current === e.target && (e.stopPropagation(), d(e));
    }),
    onKeyDown: t.wrapEvent(v, function (e) {
      "Escape" === e.key && (e.stopPropagation(), d(e));
    }),
    onMouseDown: t.wrapEvent(p, function (e) {
      g.current = e.target;
    })
  }))));
}),
    s = n.forwardRef(function (e, n) {
  var r = e.onClick,
      i = u(e, ["onClick", "onKeyDown"]);
  return o.createElement("div", Object.assign({
    "aria-modal": "true",
    role: "dialog",
    tabIndex: -1
  }, i, {
    ref: n,
    "data-reach-dialog-content": "",
    onClick: t.wrapEvent(r, function (e) {
      e.stopPropagation();
    })
  }));
}),
    f = n.forwardRef(function (e, n) {
  var r = e.isOpen,
      i = e.onDismiss,
      a = void 0 === i ? t.noop : i,
      l = e.initialFocusRef,
      f = u(e, ["isOpen", "onDismiss", "initialFocusRef"]);
  return o.createElement(c, {
    initialFocusRef: l,
    isOpen: r,
    onDismiss: a
  }, o.createElement(s, Object.assign({
    ref: n
  }, f)));
});
exports.Dialog = f, exports.DialogContent = s, exports.DialogOverlay = c, exports["default"] = f;